// client/extensions/TransformerMarkdown.ts
import { markdownTransformer } from "./transformers/markdown.js";
var TransformerMarkdown = {
  extensions: [markdownTransformer]
};
export {
  TransformerMarkdown
};
